// components/Navbar/MobileNavbar.js
"use client";
import React, { useRef, useState, useEffect } from "react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useLanguage } from '../contexts/LanguageContext'; // Custom hook
import SearchResults from "./SearchResults";
import LanguageSelector from "../components/LanguageSelector";
import MobileBottomNavigation from "./BottomNavigation";

const MobileNavbar = ({ searchProps }) => {
  // BARCHA HOOK'LAR BIRINCHI BO'LISHI KERAK - conditional rendering'dan oldin
  const { t, isHydrated } = useLanguage(); // Custom hook
  const router = useRouter();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isCallOpen, setIsCallOpen] = useState(false);
  const searchRef = useRef(null);
  const callRef = useRef(null);

  const { searchQuery, handleSearchChange, handleInputFocus, isLoading } = searchProps;

  // Click outside yopish - faqat call dropdown uchun
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (callRef.current && !callRef.current.contains(event.target)) {
        setIsCallOpen(false);
      }
    };

    if (isCallOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('touchstart', handleClickOutside);
      };
    }
  }, [isCallOpen]);

  // Body scroll ni boshqarish - search ochilganda scroll bloklansin
  useEffect(() => {
    if (isSearchOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isSearchOpen]);

  // Phone icon component
  const PhoneIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  const handlePhoneCall = (number) => {
    window.open(`tel:${number.replace(/\s/g, '')}`, '_self');
    setIsCallOpen(false);
  };

  // Category click handler
  const handleCategoryClick = (categoryId) => {
    setIsSearchOpen(false);
    router.push(`/cattegoryDatail/${categoryId}`);
  };

  // Call dropdown ichida bosilganda yopilmaslik uchun
  const handleCallDropdownClick = (e) => {
    e.stopPropagation();
  };

  // Search overlay yopish funksiyasi - faqat orqa fon bosilganda
  const handleSearchOverlayClick = (e) => {
    // Faqat overlay background bosilganda yopish
    if (e.target.classList.contains('search-overlay-bg')) {
      setIsSearchOpen(false);
    }
  };

  // Search content ichida bosilganda yopilmaslik uchun
  const handleSearchContentClick = (e) => {
    e.stopPropagation();
  };

  // ENDI HYDRATION CHECK - hook'lardan keyin
  if (!isHydrated) {
    return (
      <div className="md:hidden flex items-center gap-3">
        <div className="animate-pulse flex gap-3">
          <div className="w-10 h-10 bg-gray-200/20 rounded-full"></div>
          <div className="w-10 h-10 bg-gray-200/20 rounded-full"></div>
          <div className="w-10 h-10 bg-gray-200/20 rounded-full"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Mobile Bottom Navigation */}
      <div className="flex md:hidden fixed bottom-0">
        <MobileBottomNavigation />
      </div>

      {/* Mobile Header Actions */}
      <div className="md:hidden flex items-center gap-3">
        {/* Language Selector */}
        <LanguageSelector
          variant="mobile"
          className=""
        />

        {/* Search Button */}
        <div className="relative" ref={searchRef}>
          <button
            className="bg-white/15 backdrop-blur-md p-3 rounded-full shadow-lg border border-white/25 hover:bg-white/20 transition-all duration-200"
            onClick={() => setIsSearchOpen(!isSearchOpen)}
          >
            {isSearchOpen ? (
              // Cancel/Close icon
              <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none">
                <path
                  d="M6 18L18 6M6 6l12 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              // Search icon
              <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none">
                <path
                  d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </button>
        </div>

        {/* Call Button with Dropdown */}
        <div className="relative" ref={callRef}>
          <button
            className="bg-white/10 backdrop-blur-md p-2.5 rounded-[50%] border border-white/20 hover:bg-white/15 transition-all duration-200"
            onClick={() => setIsCallOpen(!isCallOpen)}
          >
            <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none">
              <path
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="currentColor"
              />
            </svg>
          </button>

          {/* Mobile Call Dropdown Menu */}
          {isCallOpen && (
            <div
              className="absolute right-0 top-full mt-2 min-w-[280px] animate-slide-down-mobile"
              style={{ zIndex: 10000 }}
              onClick={handleCallDropdownClick}
            >
              <div className="bg-white rounded-2xl p-5 shadow-lg border border-green-200 hover:shadow-xl transition-all duration-200 animate-fade-in-mobile">
                {/* Close button */}
                <div className="flex justify-end mb-2">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsCallOpen(false);
                    }}
                    className="text-gray-400 hover:text-gray-600 p-1 rounded-full hover:bg-gray-100 transition-all duration-200"
                  >
                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M6 18L18 6M6 6l12 12"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>

                <div className="flex items-start gap-3">
                  <div className="bg-green-100 p-2.5 rounded-xl flex-shrink-0">
                    <PhoneIcon className="w-5 h-5 text-green-600" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-gray-900 text-base mb-1">
                      {t.contact_us || "Aloqa"}
                    </h3>
                    <p className="text-sm text-gray-600 mb-3">{t.contact_message || "Biz bilan bog'laning"}</p>
                  </div>
                </div>
                <div className="space-y-2 flex flex-col">
                  <button
                    onClick={() => handlePhoneCall('+998983095550')}
                    className="text-gray-700 hover:text-green-600 transition-colors font-medium text-left hover:bg-green-50 p-2.5 rounded-lg flex items-center gap-3 w-full"
                  >
                    <div className="flex-1 text-left">
                      <div className="font-medium">+998 98 309 55 50</div>
                      <div className="text-xs text-gray-500">{t.call || "Qo'ng'iroq qilish"}</div>
                    </div>
                  </button>
                  <button
                    onClick={() => handlePhoneCall('+998949876000')}
                    className="text-gray-700 hover:text-green-600 transition-colors font-medium text-left hover:bg-green-50 p-2.5 rounded-lg flex items-center gap-3 w-full"
                  >
                    <div className="flex-1 text-left">
                      <div className="font-medium">+998 94 987 60 00</div>
                      <div className="text-xs text-gray-500">{t.call || "Qo'ng'iroq qilish"}</div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Full Screen Search Overlay - Mobile Version */}
      {isSearchOpen && (
        <div
          className="search-overlay-bg fixed inset-0 bg-black/30 backdrop-blur-sm z-[10000]"
          onClick={handleSearchOverlayClick}
        >
          <div className="w-full h-full flex flex-col">
            {/* Top section with close button */}
            <div className="flex justify-end p-2">
              <button
                onClick={() => setIsSearchOpen(false)}
                className="bg-white/10 backdrop-blur-md p-2.5 rounded-lg border border-white/20 hover:bg-white/15 transition-all duration-200"
              >
                <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M6 18L18 6M6 6l12 12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>

            {/* Main content area */}
            <div
              className="flex-1 bg-gradient-to-b from-black/40 via-black/20 to-transparent backdrop-blur-[60px] overflow-y-auto animate-slide-down-mobile"
              onClick={handleSearchContentClick}
            >
              {/* Search Input */}
              <div
                className="flex items-center gap-3 bg-gray-50/80 mx-4 mb-6 px-4 py-4 border-2 border-transparent focus-within:border-blue-500/50 focus-within:bg-white/90 transition-all duration-200 rounded-xl"
                onClick={handleSearchContentClick}
              >
                <svg className="w-6 h-6 text-gray-400 flex-shrink-0" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <input
                  type="text"
                  placeholder={t.searchPlaceholderMobile || "Qidiruv..."}
                  className="bg-transparent outline-none text-gray-700 placeholder-gray-400 flex-1 text-lg font-medium"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  onFocus={handleInputFocus}
                  onClick={handleSearchContentClick}
                  autoFocus
                  autoComplete="off"
                  spellCheck="false"
                />
                {isLoading && (
                  <div className="animate-spin rounded-full h-6 w-6 border-2 border-gray-300 border-t-blue-500 flex-shrink-0"></div>
                )}
              </div>

              {/* Popular Searches Section */}
              <div className="max-w-[95%] mx-auto mb-6">
                <h2 className="text-2xl font-bold text-white mb-4">{t.categories || "Kategoriyalar"}</h2>

                {/* Category Tags - Mobile Grid */}
                <div className="grid grid-cols-2 gap-3">
                  <button
                    onClick={() => handleCategoryClick(1)}
                    className="text-white rounded-lg py-3 bg-white/10 backdrop-blur-md p-2.5 border border-white/20 hover:bg-white/15 transition-all duration-200 text-sm"
                  >
                    {t["Dizelli transportlar"] || "Dizelli transportlar"}
                  </button>

                  <button
                    onClick={() => handleCategoryClick(2)}
                    className="text-white rounded-lg py-3 bg-white/10 backdrop-blur-md p-2.5 border border-white/20 hover:bg-white/15 transition-all duration-200 text-sm"
                  >
                    {t["Elektri transportlar"] || "Elektri transportlar"}
                  </button>

                  <button
                    onClick={() => handleCategoryClick(3)}
                    className="text-white rounded-lg py-3 bg-white/10 backdrop-blur-md p-2.5 border border-white/20 hover:bg-white/15 transition-all duration-200 text-sm"
                  >
                    {t["Benzinli transportlar"] || "Benzinli transportlar"}
                  </button>

                  <button
                    onClick={() => handleCategoryClick(5)}
                    className="text-white rounded-lg py-3 bg-white/10 backdrop-blur-md p-2.5 border border-white/20 hover:bg-white/15 transition-all duration-200 text-sm"
                  >
                    {t["Elektr pallet yuk mashinasi"] || "Elektr pallet yuk mashinasi"}
                  </button>

                  <button
                    onClick={() => handleCategoryClick(6)}
                    className="text-white rounded-lg py-3 bg-white/10 backdrop-blur-md p-2.5 border border-white/20 hover:bg-white/15 transition-all duration-200 text-sm"
                  >
                    {t["Elektr stacker mashinaslari"] || "Elektr stacker mashinaslari"}
                  </button>

                  <button
                    onClick={() => handleCategoryClick(7)}
                    className="text-white rounded-lg py-3 bg-white/10 backdrop-blur-md p-2.5 border border-white/20 hover:bg-white/15 transition-all duration-200 text-sm"
                  >
                    {t["Reach truck forklift"] || "Reach truck forklift"}
                  </button>

                  <button
                    onClick={() => handleCategoryClick(8)}
                    className="text-white rounded-lg py-3 bg-white/10 backdrop-blur-md p-2.5 border border-white/20 hover:bg-white/15 transition-all duration-200 text-sm"
                  >
                    {t["Handle pallet forklift"] || "Handle pallet forklift"}
                  </button>

                  <button
                    onClick={() => handleCategoryClick(9)}
                    className="text-white rounded-lg py-3 bg-white/10 backdrop-blur-md p-2.5 border border-white/20 hover:bg-white/15 transition-all duration-200 text-sm"
                  >
                    {t["Texnika extiyot qismlarin"] || "Texnika extiyot qismlarin"}
                  </button>
                </div>
              </div>

              {/* Search Results */}
              <div className="max-h-96 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
                <SearchResults
                  isMobile={true}
                  searchProps={{
                    ...searchProps,
                    setIsSearchOpen
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Custom CSS Animations - Mobile */}
      <style jsx>{`
        @keyframes fade-in-mobile {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes slide-down-mobile {
          from {
            opacity: 0;
            transform: translateY(-15px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in-mobile {
          animation: fade-in-mobile 0.25s ease-out;
        }

        .animate-slide-down-mobile {
          animation: slide-down-mobile 0.3s ease-out;
        }
      `}</style>
    </>
  );
};

export default MobileNavbar;